import { type TranslationTree } from '@/i18n/types';

export const messages = {
  title: 'Eventos',
  create: 'Novo evento',
  loadError: 'Não foi possível carregar os eventos',
} satisfies TranslationTree;
